import { makeStyles } from "@mui/styles";
import { Theme } from "@mui/material/styles";

const useStyles = makeStyles((theme: Theme) => ({
  container: {
    justifyContent: "center",
    alignItems: "center",
    width: "100%",
    height: "100%",
    minHeight: "100vh",
    direction: "ltr",
    backgroundColor: theme.colors.white,
    [theme.breakpoints.down("desktop")]: {
      paddingTop: 55,
    },
  },

  desktopContainer: {
    width: "100%",
    height: "100%",
    display: "flex",
  },

  contentContainer: {
    width: "100%",
    minHeight: "100vh",
    height: "100%",
    display: "flex",
    padding: "0 70px",
    [theme.breakpoints.down("desktop")]: {
      padding: "0 20px",
      paddingTop: 20,
      minHeight: "calc(100vh - 55px)",
    },
  },
  leftSide: {
    width: "640px",
  },
  rightSide: {
    width: "calc(100% - 640px)",
    backgroundColor: "#E4F5EC",
  },

  GalleryLayout_leftSide: {
    width: "640px",
  },

  GalleryLayout_rightSide: {
    height: "100vh",
    width: "calc(100% - 640px)",
    backgroundColor: "#e4f5ec",
  },
}));

export default useStyles;
